import { useRouter } from '@tanstack/react-router';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { CompanyDetailsForm } from '@/components/company/CompanyDetailsForm';
import { api } from '@/lib/api';
import { type OnboardingCompanyForm } from '@/lib/schemas';

/**
 * /onboarding/company — порт frontend/src/app/onboarding/company/page.tsx (AntD → shadcn).
 *
 * Standalone-страница (lighter shell, без sidebar/AppShell). Earth Tech.
 * Создаёт титульную компанию (юр.лицо с договором) и редиректит на /dashboard.
 *
 * AK-350: поля формы вынесены в общий CompanyDetailsForm (переиспользуется
 * вкладкой «Профиль» раздела «Компания»). Здесь — только shell + POST-логика.
 */
export function OnboardingCompanyPage() {
  const router = useRouter();

  const onSubmit = async (data: OnboardingCompanyForm) => {
    const payload = {
      name: data.name,
      short_name: data.short_name || null,
      logo_url: null,
      brand_color: data.brand_color || null,
      legal_entity_name: data.legal_entity_name || null,
      inn: data.inn || null,
      ogrn: data.ogrn || null,
      kpp: data.kpp || null,
      legal_address: data.legal_address || null,
      actual_address: data.actual_address || null,
      director_name: data.director_name || null,
      director_phone: data.director_phone || null,
      director_email: data.director_email || null,
      default_currency_code: data.default_currency_code || 'RUB',
    };
    await api.post('/api/v1/companies', payload);
    router.navigate({ to: '/dashboard' });
  };

  return (
    <div className="min-h-dvh bg-secondary/40">
      {/* Light top branding (no sidebar) */}
      <header className="bg-card border-b border-border">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center">
          <span className="text-base font-semibold">ИИ-Колхоз</span>
          <span className="ml-3 text-sm text-muted-foreground">
            · Создание компании
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-xl">Создайте компанию</CardTitle>
            <CardDescription>
              Это титульное юр.лицо, с которым у нас заключён договор. Позже можно
              добавить ещё юр.лица как хозяйства (в случае холдинга).
            </CardDescription>
          </CardHeader>
          <CardContent>
            <CompanyDetailsForm mode="create" onSubmit={onSubmit} />
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

export default OnboardingCompanyPage;
